<h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="dlg-drag-handle" cdkDragHandle>
        <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
            <path
                    d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
            </path>
            <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
    </div>
</h1>
<div fxFlex="row" mat-dialog-content>
    <div class="mainHeaderCode">
        <button style="position: relative; top: 5px" class="icon-button buttonBarButt" mat-raised-button (click)="copyEmbeddedToClipboard()">
            <mat-icon class="buttonBarIcon">content_copy</mat-icon>&nbsp;&nbsp;
        </button>
        <div>
            @switch (codeTemplateId) {
                @case ('1') {
                    <div>
                        <h1></h1>
                    </div>
                }
                @case ('2') {
                    <div>
                        <h1>Embed the following code in your HTML page so you can play it inside a web site</h1>
                    </div>
                }
                @case ('3') {
                    <div>
                        <h1>Node.js express server code example to receive player updates</h1>
                    </div>
                }
                @default {
                    <div>
                        <h1>Code default</h1>
                    </div>
                }
            }
        </div>
    </div>
    <pre><code [highlight]="embeddedCode" [lineNumbers]="true"></code></pre>
</div>
